import React from 'react';
import { CardWrapper } from './styles';
import { Button } from 'antd';
import { t } from 'i18next';
import ConfirmModal from '../components/Modal/ConfirmModal';
import { useDispatch } from '@redux';
import crudActions from '@redux/crudActions';
import CancelOrderModal from '../components/Modal/CancelOrderModal';

const Validation = ({ data }) => {
  const dispatch = useDispatch();

  const cancelOrderModalRef = React.useRef(null);

  const handleConfirmModal = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['confirm']: {
          isOpen: value,
        },
      } as any),
    );
  };

  return (
    <CardWrapper title="Validation">
      <div className="flex gap-5 w-full">
        <Button
          className="w-full h-[40px]"
          onClick={() => cancelOrderModalRef.current?.openModal()}
        >
          {t('button.cancel')}
        </Button>
        <Button
          type="primary"
          className="w-full h-[40px]"
          onClick={() => handleConfirmModal(true)}
        >
          {t('button.approve')}
        </Button>
      </div>
      <ConfirmModal onCancel={() => handleConfirmModal(false)} />
      <CancelOrderModal ref={cancelOrderModalRef} data={data} />
    </CardWrapper>
  );
};

export default Validation;
